import { setSorting } from './actions';
import { updateSorting } from './thunk';

export { setSorting, updateSorting };
